import { render } from "./TheAppTable.vue?vue&type=template&id=c8bf781c"
const script = {}

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__